import React, { useEffect, useState } from 'react';
import { subscribeInternetError } from '../utils/internetError';

export default function InternetErrorBanner() {
  const [show, setShow] = useState(() => typeof navigator !== 'undefined' && navigator.onLine === false);

  useEffect(() => subscribeInternetError(setShow), []);

  if (!show) return null;

  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10000,
        background: '#9f1239',
        color: '#fff',
        textAlign: 'center',
        padding: '10px 16px',
        fontSize: '15px',
        fontWeight: 600,
        lineHeight: 1.4,
        boxShadow: '0 2px 8px rgba(0,0,0,0.25)'
      }}
    >
      Internet error. Could not connect to the database or load data from the internet. Check your internet connection and try again.
    </div>
  );
}
